import type { ToastApi } from '../components/ui/ToastProvider'

/**
 * Toast köprüsü (019). axios interceptor ve TanStack Query global onError React ağacı dışındadır;
 * `useToast()` context'ine erişemezler. `ToastProvider` mount'ta kendi API'sini burada kaydeder;
 * React-dışı kod `getToast()` ile mevcut tek `<Toast>` üzerinden bildirim gösterir (Reuse Mandate).
 */

let current: ToastApi | null = null

export function registerToast(api: ToastApi | null): void {
  current = api
}

export function getToast(): ToastApi | null {
  return current
}
